import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from "rxjs/Observable";

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';

import * as globalConst from './../../../../constants';


@Injectable()
export class AttachmentEditService {

  private apiUrl = globalConst.baseAPI;

  constructor(private http: Http) { }

  loadAttachment(token, ID) {

		return this.http
		.get(this.apiUrl + "documents/v1/getcodattachment/" + ID, JSON.parse(localStorage.getItem('yara.connectionHeader')))
		.map((res: Response) => res.json())
		.catch(e => {
			if (e.status === 401) {
				return Observable.throw('Unauthorized');
			}
		});
  }

  editAttachment(token, attachment: any) {

		return this.http
		.put(this.apiUrl + "documents/v1/updateattachment", attachment, JSON.parse(localStorage.getItem('yara.connectionHeader')))
		.map((res: Response) => res.json())
		.catch(e => {
			if (e.status === 401) {
				return Observable.throw('Unauthorized');
			}
		});
	}

}



// WEBPACK FOOTER //
// ./src/app/attachment/service/attachment-edit/attachment-edit.service.ts